<template>
	<Teleport to="body">
	<div class="languages-wrapper">

		<div class="langModal">
			<MaoButton icon="close" variant="text-button-opacity-light" @click="() => closeModal()" />
			<div class="languages " :class="{ active: langs }">
				<h2 class="text body-big-semibold">{{ appData.labels['Select your language'] }}</h2>
				<MaoButton v-for="lang in appData.languages.langs" :key="lang" variant="text-button-opacity-light" :status="!isLangSupported(lang)? 'lang-disabled' : ''" :label="lang.native_name" @click="() => changeLang(lang.code)" />
			</div>
		</div>

	</div>
	</Teleport>
</template>
<script>
import MaoButton from "./MaoButton.vue";
import { useAppDataStore } from "./../stores/appData";
import { useGlobalActionsStore } from "./../stores/globalActions";

export default {
	name: "MaoLangModal",
	methods: {
		closeModal() {
			this.$emit("close");
		},
		changeLang(lang) {
			//this.setLang(lang, this.$router);
			this.loadLang(lang, this.$router);
			this.$emit("onSelectLang", lang);
			this.$emit("close");
		},
		isLangSupported(lang) {
			const currentId = this.$route.params.id;
			if (!currentId) {
				return true;
			}

			return this.findTranslation(currentId, lang.code);
		},
	},
	setup() {
		const { appData, setLang, loadLang, findTranslation } = useAppDataStore();
		const globalActionsStore = useGlobalActionsStore();
		
		return { appData, setLang, loadLang, globalActionsStore, findTranslation};
	},
	components: {
		MaoButton
	},
	props: {
		
	},
};
</script>

<style scoped lang="scss">
.langModal {
	width: 90%;
	max-width: 340px;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
}
.languages-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 100;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;

	h2 {
		color: var(--surface-background-standard);
	}
	.languages {
		position: relative;
		border-radius: var(--border-radius-l);
		z-index: 260;
		background-color: var(--surface-background-variant-dark);
		display: flex;
		flex-direction: column;
		padding: 1rem 2rem;
		width: 100%;
		.close-button {
			position: absolute;
			top: -1rem;
			right: -1rem;
		}
	}
}
</style>
